import { useState } from "react";
import { View, Text, TouchableOpacity, Pressable } from "react-native";
import { useDispatch } from "react-redux";
import styles from "./styles";
import { Feather } from "@expo/vector-icons";
import { AppDispatch, RootState } from "../../../redux/store";
import { logout } from "../../../redux/slices/authSlice";
import {
  NavigationProp,
  ParamListBase,
  useNavigation,
} from "@react-navigation/native";
import { navigateToHomeFeed } from "../../../utils/navigationFallback";

export default function ProfileNavBar({
  user,
}: {
  user: RootState["auth"]["currentUser"];
}) {
  const navigation = useNavigation<NavigationProp<ParamListBase>>();
  const dispatch = useDispatch<AppDispatch>();
  const [menuOpen, setMenuOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const goHome = () => {
    setMenuOpen(false);
    navigateToHomeFeed(navigation);
  };
  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await dispatch(logout()).unwrap();
      setMenuOpen(false);
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    user && (
      <View style={styles.container}>
        <TouchableOpacity
          accessibilityRole="button"
          accessibilityLabel="返回主页"
          style={styles.backButton}
          onPress={goHome}
        >
          <Feather name="arrow-left" size={22} />
          <Text style={styles.backText}>主页</Text>
        </TouchableOpacity>
        <Text style={styles.text}>{user.email}</Text>
        <TouchableOpacity
          accessibilityRole="button"
          accessibilityLabel={
            menuOpen ? "关闭个人中心菜单" : "打开个人中心菜单"
          }
          accessibilityState={{ expanded: menuOpen }}
          style={styles.menuButton}
          onPress={() => setMenuOpen((open) => !open)}
        >
          <Feather name="menu" size={24} />
        </TouchableOpacity>
        {menuOpen && (
          <>
            <Pressable
              style={styles.menuBackdrop}
              onPress={() => setMenuOpen(false)}
            />
            <View style={styles.menuPanel}>
              <TouchableOpacity
                style={styles.menuItem}
                onPress={() => {
                  setMenuOpen(false);
                  navigation.navigate("editProfile");
                }}
              >
                <Feather name="edit-2" size={17} color="#222" />
                <Text style={styles.menuItemText}>编辑资料</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.menuItem} onPress={goHome}>
                <Feather name="home" size={17} color="#222" />
                <Text style={styles.menuItemText}>返回首页</Text>
              </TouchableOpacity>
              <TouchableOpacity
                accessibilityRole="button"
                accessibilityLabel="退出登录"
                accessibilityState={{ disabled: loggingOut }}
                disabled={loggingOut}
                style={styles.menuItem}
                onPress={() => void handleLogout()}
              >
                <Feather name="log-out" size={17} color="#d74646" />
                <Text style={styles.logoutText}>
                  {loggingOut ? "正在退出…" : "退出登录"}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.menuItem}
                onPress={() => setMenuOpen(false)}
              >
                <Feather name="x" size={17} color="#222" />
                <Text style={styles.menuItemText}>关闭菜单</Text>
              </TouchableOpacity>
            </View>
          </>
        )}
      </View>
    )
  );
}
